import React from 'react'
import AppBar from "@material-ui/core/AppBar";
import { withStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import MenuIcon from "@material-ui/icons/Menu";
import IconButton from "@material-ui/core/IconButton";
import { Link } from "react-router-dom";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Home from "@material-ui/icons/Home";
import Face from "@material-ui/icons/Face";
import ListIcon from '@material-ui/icons/List';
import Contact from '@material-ui/icons/ContactMail';
import ReactDOM from 'react-dom';

const styles = theme => ({
    root: {
  
      boxShadow: '0 0 5px rgba(0,0,0,.5)',
      paddingTop: '56px',
      [theme.breakpoints.up("sm")]: {
        paddingTop: '0'
      }
    },
    grow: {
        flexGrow: 1
    },
    appBar: {
        backgroundColor: theme.palette.custom.nav,
        
    },
    button: {
        margin: theme.spacing.unit,
        color: 'white',
        

    },
    link: {
        color: 'white',
    },
    sectionMobile: {
        color: 'white',
        [theme.breakpoints.up("sm")]: {
            display: "none"
          }
    },

    sectionDesktop: {
        display: "none",
        width: '100%',
        [theme.breakpoints.up("sm")]: {
          display: "block"
        }
      },
      nested: {
        paddingLeft: theme.spacing.unit * 4
      },
      drawer: {
        width: "50%"
      }
});
    


class Navigation extends React.Component {

    constructor(props) {
        
        super(props);

    }

    state = {
        mobileMenu: null,
        drawer: false,
        mobile: false
    };

    toggleDrawer = open => () => {
        this.setState({
          drawer: open
        });
    };

    componentDidUpdate() {
        
        //smoothscroll.polyfill();
        //window.scroll({ top: 0, left: 0, behavior: 'smooth' });
        ReactDOM.findDOMNode(this).scrollIntoView({  behavior: 'smooth' });
        //console.log('scrolling to top');

    }

    componentDidMount() {
        window.addEventListener("resize", this.resize);
        this.resize();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resize);
    }

    resize = () => {

        if (window.innerWidth > 600 && this.state.mobile === true) {

            this.setState({mobile: false});

        } else if (window.innerWidth < 600 && this.state.mobile === false) {

            this.setState({mobile: true});

        }
    }

    render () {

        const { classes } = this.props;

        const renderDrawer = (

            <Drawer open={this.state.drawer} onClose={this.toggleDrawer(false)}>
            <div
              tabIndex={0}
              role="button"
              onClick={this.toggleDrawer(false)}
              onKeyDown={this.toggleDrawer(false)}
            >
              <div className={classes.list}>
                <List>
                  <Link to="/">
                    <ListItem button>
                      <ListItemIcon>
                        <Home />
                      </ListItemIcon>
                      <ListItemText primary={"Home"} />
                    </ListItem>
                  </Link>
                </List>
    
                <Divider />
                <List>
                  <ListItem button component={Link} to="/about">
                    <ListItemIcon>
                      <Face/>
                    </ListItemIcon>
                    <ListItemText primary={"About"} />
                  </ListItem>
                  <ListItem button component={Link} to="/projects">
                    <ListItemIcon>
                      <ListIcon/>
                    </ListItemIcon>
                    <ListItemText primary={"Projects"} />
                  </ListItem>
                  <ListItem button component={Link} to="/contact">
                    <ListItemIcon>
                      <Contact/>
                    </ListItemIcon>
                    <ListItemText primary={"Contact"} />
                  </ListItem>
                </List>
              </div>
            </div>
          </Drawer>
        );


        return (
        <div className={classes.root}>
            <AppBar position={this.state.mobile ? "fixed" : "sticky"} className={classes.appBar}>
                <Toolbar>
                    <div className={classes.sectionMobile}>
                        <IconButton
                            className={classes.menuButton}
                            color="inherit"
                            aria-label="Open drawer"
                            onClick={this.toggleDrawer(true)}
                        >
                            <MenuIcon />
                        </IconButton>
                        {renderDrawer}
                    </div>

                    <div className={classes.sectionDesktop}>
                        <div className={classes.grow} />
                        <Grid container justify="center" alignItems="center" className={classes.body} >
                            <Grid item>

                                <Button size="large" component={Link} to="/" className={classes.button}>
                                    Home
                                </Button>
                                
                                <Button size="large" component={Link} to="/about" className={classes.button}>
                                    About
                                </Button>

                                <Button size="large" component={Link} to="/projects" className={classes.button}>
                                    Projects
                                </Button>

                                <Button size="large" component={Link} to="/contact" className={classes.button}>
                                    Contact
                                </Button>
                                
                            </Grid>

                        </Grid>
                    </div>
                </Toolbar>
            </AppBar>

        </div>)
    }


};




  




export default withStyles(styles)(Navigation)
